export default __webpack_public_path__ + "static/media/querelle_detail7.552ad93f.jpg";